import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * ProductItem - used in Products
 *
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class ProductItem extends Component {

    /**
     * Prop types
     *
     * @type {{description: shim, image: shim, ingredients, ingredientsImage: shim, openModalPopup: shim, title: shim, type: shim}}
     */
    static propTypes = {
        description: PropTypes.string,
        image: PropTypes.string,
        ingredients: PropTypes.arrayOf(PropTypes.string),
        ingredientsImage: PropTypes.string,
        openModalPopup: PropTypes.func,
        title: PropTypes.string,
        type: PropTypes.string
    };

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        const {image, index, openModalPopup, type} = this.props;

        return (
            <li>
                {/* <div>{description}</div> */}
                <img src={image}
                     data-index={index}
                     data-type={type}
                     alt="Product"
                     onClick={openModalPopup}/>
                {/* <div>{ingredients}</div> */}
                {/* <img src={ingredientsImage}/> */}
                {/* <div>{title}</div> */}
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/page/filterProducts/ProductItem.jsx